import './setup';
import './Theme';
import App from './App.vue';
import Router from './Router';
import Store from './Store';
import Vue from 'vue';

/**
 * Register the PWA service worker in production so the app is installable on
 * Meta Quest (Horizon OS requires a registered service worker) and supports
 * warm, offline-capable reloads. Skipped in development to avoid interfering
 * with the dev server's hot-module reloading.
 *
 * @return void
 */
function registerServiceWorker(): void {
	if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) {
		return;
	}

	window.addEventListener('load', () => {
		navigator.serviceWorker.register('/service-worker.js').catch((error) => {
			console.error('[main] Service worker registration failed:', error);
		});
	});
}

(async function () {
	new Vue({
		render: (h) => h(App),
		router: Router,
		store: Store,
	}).$mount('#app');

	registerServiceWorker();
})();
